<template>
  <j-modal :title="title" width="70%" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '600px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="false">
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <template slot="inspectionTaksRouteDeviceFilePath1" slot-scope="text,record">
            <div style="display: flex;align-items: center;">
              <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==1">
                <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
                <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </template>
          <template slot="inspectionTaksRouteDeviceFilePath2" slot-scope="text,record">
            <div style="display: flex;align-items: center;">
              <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==2">
                <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
                <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </template>
        </a-table>
      </j-form-container>
    </a-spin>
    <a-modal :title="$t('预览')" :width="700" :visible="visiblePirture" :footer="null" @cancel="imghandleCancel">
      <img alt="example" style="width: 100%;height: 100%;" :src="viewUrl.url" v-if="viewUrl.fileType == 'image'"/>
      <video controls :src="viewUrl.url" style="width: 100%;height: 100%;" v-if="viewUrl.fileType == 'video'"></video>
    </a-modal>
  </j-modal>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default {
    name: 'historyModal',
    mixins:[JeecgListMixin],
    components: {},
    data() {
      return {
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        url: {
          list :"/jeecg-engineering/inspection/InspectionTaskRouteDevice/list",
          list1 :"/jeecg-engineering/inspection/InspectionTaskRouteDevice/list",
          list2: "/jeecg-engineering/inspection/inspectionDevice/queryByDevice",
        },
        queryParam:{},
        visiblePirture: false,
        viewUrl: {},
        isMap: false
      }
    },
    computed: {
      title() {
        return this.$t('历史数据')
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            width: 150,
            ellipsis:true
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            width: 150,
            ellipsis:true
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude',
            width: 150,
            ellipsis:true
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude',
            width: 150,
            ellipsis:true
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (t,r,indnx) => {
              return filterDictTextByCache('deviceType',t)
            },
            width: 150,
            ellipsis:true
          },
          {
            title: this.$t('巡检人员'),
            align:"center",
            dataIndex: 'updateBy',
            width: 150,
          },
          {
            title: this.$t('巡检时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 150,
          },
          {
            title: this.$t('是否存在问题'),
            align: "center",
            dataIndex: 'abnormalOrNot',
            width: 100,
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('是');
              } else if (t == 2) {
                return this.$t('否');
              }
            }
          },
          {
            title: this.$t('运行状态'),
            align: "center",
            dataIndex: 'runOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('正常');
              } else if (t == 2) {
                return this.$t('异常');
              }
            },
            width: 100,
          },
          {
            title: this.$t('问题描述'),
            align: "center",
            dataIndex: 'exceptionDescription',
            width: 200,
            ellipsis: true,
          },
          {
            title: this.$t('巡检结果'),
            align: "center",
            dataIndex: 'isOk',
            customRender: (t, r, index) => {
              if (t == 0) {
                return this.$t('正常');
              } else if (t == 1) {
                return this.$t('异常');
              }
            },
            width: 100,
          },
          {
            title: this.$t('解决前照片或视频'),
            align: "center",
            width: 200,
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath1'
            }
          },
          {
            title: this.$t('解决后照片或视频'),
            align: "center",
            width: 200,
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath2'
            }
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark',
            width: 150,
            ellipsis: true,
          },
        ]
      },
    },
    methods: {
      init(row){
        this.visible = true;
        this.disableSubmit = true;
        this.queryParam = {
          deviceId: row.id,
        }
        this.isMap = row.isMap;
        if(row.isMap){
          this.url.list = this.url.list2;
        }else{
          this.url.list = this.url.list1;
          this.queryParam.isHistory = 1;
        }
        let params = {...this.getQueryParams(),...this.queryParam};
        getAction(this.url.list,params).then((res)=>{
          if(res.success){
            if(row.isMap){
              this.dataSource = res.result;
              this.ipagination.total = res.result.length;
            }else{
              this.dataSource = res.result.records;
              this.ipagination.total = res.result.total;
            }
          }
        })
      },
      handleTableChange(pagination, filters, sorter){
        this.ipagination = pagination;
        if(this.isMap){
          this.url.list = this.url.list2;
        }else{
          this.url.list = this.url.list1;
          this.queryParam.isHistory = 1;
        }
        let params = {...this.getQueryParams(),...this.queryParam};
        getAction(this.url.list,params).then((res)=>{
          if(res.success){
            if(this.isMap){
              this.dataSource = res.result;
              this.ipagination.total = res.result.length;
            }else{
              this.dataSource = res.result.records;
              this.ipagination.total = res.result.total;
            }
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      // 预览图片
      viewPicture(item){
        this.visiblePirture = true;
        this.viewUrl = item;
      },
      imghandleCancel(){
        this.visiblePirture = false;
      }
    }
  }
</script>